import { NgFor, NgIf } from "@angular/common";
import { Component, ViewEncapsulation, inject } from "@angular/core";
import { MatButtonModule } from "@angular/material/button";
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from "@angular/material/dialog";
import { MatIconModule } from "@angular/material/icon";
import { NiceAlertConfig } from "@recursyve/nice-ui-kit.v2";

@Component({
    selector: "fmp-custom-alert",
    imports: [MatButtonModule, MatDialogModule, MatIconModule, NgFor, NgIf],
    templateUrl: "./custom-alert.template.html",
    styleUrls: ["./custom-alert.style.scss"],
    encapsulation: ViewEncapsulation.None
})
export class CustomAlertComponent {
    protected readonly alertConfig = inject<NiceAlertConfig | undefined>(MAT_DIALOG_DATA);

    private readonly dialogRef = inject<MatDialogRef<CustomAlertComponent>>(MatDialogRef);

    protected confirm(): void {
        this.dialogRef.close(true);
    }

    protected close(): void {
        this.dialogRef.close(false);
    }
}
